const styles = {
    chartTitle: {
        fontSize: 18,
        fontWeight: '600',
        color: '#161728',
        width: '100%',
        marginBottom: '16px',
    },
    chartContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: 150,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        margin: 5,
    },
    buttonBottom: {
        backgroundColor: '#FFFFFF',
        color: '#70707A',
        marginRight: '20px',
        height: 26,
        width: 46,
        fontSize: 12,
        fontWeight: '400',
        borderRadius: 8,
    },
    selectedButtonBottom: {
        backgroundColor: '#161728',
        color: '#FFFFFF',
        marginRight: '20px',
        height: 26,
        width: 46,
        fontSize: 12,
        fontWeight: '400',
        borderRadius: 8,
    },

    //Doughnut chart styles
    doughnutChartContainer: {
        height: '174px',
        width: '95%',
        borderRadius: '10px',
        background: '#FAFAFA',
        marginTop: '5px',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'row' as const,
    },
    doughnutContainer: {
        height: '100%',
        width: '45%',
        marginRight: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative' as const,
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    },
    colorDot: {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        marginRight: '5px',
    },
    labelText: {
        minWidth: '135px',
        display: 'inline-block',
        fontSize: '14px',
    },
    valueText: {
        marginLeft: 'auto',
        fontWeight: 'bold',
        fontSize: '14px',
    },
    innerCenterText: {
        position: 'absolute' as const,
        whiteSpace: 'pre-line' as const,
        textAlign: 'center' as const,
        fontSize: '10px',
    },
    innerTextSpan: {
        fontSize: '23px',
        color: '#161729',
        fontWeight: '400'
    },
};

export default styles;
